<template>
  <app-layout>
    <b-navbar toggleable="md" class="row my-3 pl-0" style="height: unset">
      <b-navbar-toggle
        target="subnav"
        style="margin-left: 15px"
      ></b-navbar-toggle>
      <b-navbar-brand href="#">
        <h1 class="col-sm-12 h3 text">{{ $t("team-page-title") }}</h1>
        <div class="col-md-12 mb-2 d-flex" style="flex-wrap: wrap">
          <b-button
            @click="goToDiscussion('agency')"
            class="mr-4 mt-2 text"
            variant="primary"
            v-if="showAgencyDiscussion"
          >
            {{ $t("discuss-agency-btn") }}
          </b-button>
          <b-button
            v-if="showAdvTeamDiscussion"
            @click="goToDiscussion('adv')"
            variant="primary"
            class="mt-2 text"
          >
            {{ $t("discuss-team-btn") }}
          </b-button>
        </div>
      </b-navbar-brand>
      <b-collapse is-nav id="subnav" class="c-subnav">
        <b-navbar-nav v-b-scrollspy class="ml-auto">
          <b-nav-item href="#carers">{{
            $t("team-page-speakers-title")
          }}</b-nav-item>
          <b-nav-item href="#employees">{{
            $t("team-page-account-managers-title")
          }}</b-nav-item>
          <b-nav-item href="#agency">{{
            $t("team-page-agency-title")
          }}</b-nav-item>
        </b-navbar-nav>
      </b-collapse>
    </b-navbar>

    <vita-mes-intervenants></vita-mes-intervenants>
    <vita-mes-cdc></vita-mes-cdc>
    <vita-cda></vita-cda>
    <vita-mon-agence></vita-mon-agence>
  </app-layout>
</template>

<script>
import AppLayout from "../../layouts/AppLayout.vue";
import VitaMesIntervenants from "./Intervenants/Intervenants.vue";
import VitaMesCdc from "./CDC/CDC.vue";
import VitaMonAgence from "./Agence/Agence.vue";
import VitaCda from "./CDA/CDA.vue";
import activation from "../Mixins/activation";

export default {
  name: "Team",
  components: {
    AppLayout,
    VitaMesIntervenants,
    VitaMesCdc,
    VitaMonAgence,
    VitaCda
  },
  mixins: [activation],
  methods: {
    goToDiscussion(type) {
      this.$router.push({
        path: "/discussions",
        query: {
          type: type
        }
      });
    }
  }
};
</script>
<style scoped lang="scss">
.text {
  white-space: normal;
  overflow-wrap: break-word;
  word-break: break-word;
}
</style>
